import { Select, type ISelectProps } from '@procurify/ui'
import { useIntl } from 'react-intl'

import { type Currency } from '@webapp/core/entities/external/Currency'
import messages from './messages'
import { useCurrencySelect } from './useCurrencySelect'

export const CurrencySelect = (props: ISelectProps<Currency>) => {
  const intl = useIntl()

  const {
    data: { currencies },
    states: { isFetching },
  } = useCurrencySelect()

  return (
    <Select<Currency>
      options={currencies}
      isLoading={isFetching}
      getOptionLabel={(opt) => opt.name}
      getOptionValue={(opt) => opt.id.toString()}
      placeholder={intl.formatMessage(messages.selectPlaceholderText)}
      {...props}
    />
  )
}

CurrencySelect.displayName = 'CurrencySelect'
